import { AppRouterProvider as F } from "../AppRouterProvider/AppRouterProvider.js";
import { useDatadog as G } from "../../../hooks/useDatadog/useDatadog.js";
import { hasNavigationGuards as U, runNavigationGuards as z } from "../../../helpers/navigationGuard.helper.js";
import { NavigationCancelledError as w } from "./ReactRouterAdapter.types.js";
import { useCallback as R, useEffect as T, useMemo as D, useRef as g } from "react";
import { jsx as M } from "react/jsx-runtime";
import { generatePath as O, matchRoutes as k, resolvePath as N, useBlocker as H, useLocation as I, useNavigate as J } from "react-router";
var C = (a, n, o = []) => {
  for (const e of a) {
    const t = e.path !== void 0 ? [...o, e] : o;
    if (e.id === n) return t;
    if (e.children) {
      const r = C(e.children, n, t);
      if (r) return r;
    }
  }
}, x = (a) => {
  if (!a) return "";
  const n = new URLSearchParams();
  Object.entries(a).forEach(([e, t]) => {
    t != null && (Array.isArray(t) ? t.forEach((r) => r != null && n.append(e, r)) : n.append(e, t));
  });
  const o = n.toString();
  return o ? `?${o}` : "";
}, K = (a) => {
  const n = new URLSearchParams(a), o = {};
  return n.forEach((e, t) => {
    const r = o[t];
    r === void 0 ? o[t] = e : o[t] = Array.isArray(r) ? [...r, e] : [r, e];
  }), o;
}, A = (a, n, o, e = {}) => {
  if (typeof n == "string") {
    const t = N(n, o);
    return {
      pathname: t.pathname,
      search: t.search,
      hash: t.hash
    };
  }
  if (n.name) {
    const t = C(a, n.name);
    if (!t) throw new Error(`ReactRouterAdapter: no route named "${n.name}"`);
    const r = `/${t.map((p) => p.path).filter(Boolean).join("/")}`.replace(/\/{2,}/g, "/"), m = {
      locale: e.locale,
      ...n.params
    };
    return {
      pathname: O(r, m),
      search: x(n.query),
      hash: n.hash ?? ""
    };
  }
  if (n.path) {
    const t = N(n.path, o);
    return {
      pathname: t.pathname,
      search: n.query ? x(n.query) : t.search,
      hash: n.hash ?? t.hash
    };
  }
  return {
    pathname: o,
    search: "",
    hash: n.hash ?? ""
  };
}, P = (a, n, o, e) => {
  const t = k(a, n) ?? [], r = t[t.length - 1], m = r ? r.params : {}, p = r ? r.route.handle ?? void 0 : void 0;
  return {
    path: n,
    name: r?.route.id ?? null,
    hash: e,
    query: K(o),
    params: m,
    fullPath: `${n}${o}${e}`,
    matched: t.map((y) => ({
      ...y.route,
      name: y.route.id ?? null
    })),
    meta: p
  };
}, ee = ({ routes: a, children: n }) => {
  const o = J(), e = I(), { trace: t } = G("ReactRouterAdapter"), r = g(P(a, e.pathname, e.search, e.hash));
  r.current = P(a, e.pathname, e.search, e.hash);
  const m = g(/* @__PURE__ */ new Set()), p = g(/* @__PURE__ */ new Set()), y = g(r.current), u = g(null);
  T(() => {
    m.current.forEach((c) => c(r.current)), u.current?.resolve(r.current), u.current = null, y.current = r.current;
  }, [
    e.pathname,
    e.search,
    e.hash
  ]);
  const l = H(R(() => p.current.size > 0 || U(), []));
  T(() => {
    if (l.state !== "blocked") return;
    const c = P(a, l.location.pathname, l.location.search, l.location.hash), s = y.current;
    (async () => {
      if (!await z(c)) {
        u.current?.reject(new w("guard")), u.current = null, l.reset();
        return;
      }
      for (const h of p.current) if (!await h(c, s)) {
        u.current?.reject(new w("guard")), u.current = null, l.reset();
        return;
      }
      l.proceed();
    })();
  }, [l, a]);
  const $ = R((c) => {
    const { pathname: s, search: h, hash: i } = A(a, c, e.pathname, r.current.params), f = typeof c == "object" && !!c.replace;
    if (P(a, s, h, i).fullPath === r.current.fullPath) return Promise.resolve(r.current);
    const d = new Promise((v, B) => {
      u.current?.reject(new w("superseded")), u.current = {
        resolve: v,
        reject: B
      }, o({
        pathname: s,
        search: h,
        hash: i
      }, { replace: f });
    });
    return d.catch((v) => {
      v instanceof w || t(v, { source: "ReactRouterAdapter.navigateTo" });
    }), d;
  }, [
    o,
    a,
    e.pathname,
    t
  ]), j = R((c) => {
    const { pathname: s, search: h, hash: i } = A(a, c, e.pathname, r.current.params);
    if (P(a, s, h, i).fullPath === r.current.fullPath) return Promise.resolve(r.current);
    const f = new Promise((d, v) => {
      u.current?.reject(new w("superseded")), u.current = {
        resolve: d,
        reject: v
      }, o({
        pathname: s,
        search: h,
        hash: i
      }, { replace: !0 });
    });
    return f.catch((d) => {
      d instanceof w || t(d, { source: "ReactRouterAdapter.replaceTo" });
    }), f;
  }, [
    o,
    a,
    e.pathname,
    t
  ]), b = R(() => r.current, []), q = R((c) => {
    const { pathname: s, search: h, hash: i } = A(a, c, e.pathname, r.current.params), f = P(a, s, h, i);
    return {
      location: {
        path: s,
        hash: i,
        query: f.query
      },
      route: f,
      href: `${s}${h}${i}`
    };
  }, [a, e.pathname]), E = R((c) => (m.current.add(c), () => m.current.delete(c)), []), S = R((c) => (p.current.add(c), () => p.current.delete(c)), []), L = D(() => ({
    navigateTo: $,
    replaceTo: j,
    getCurrent: b,
    resolveRoute: q,
    onRouteChange: E,
    interceptNavigation: S
  }), [
    $,
    j,
    b,
    q,
    E,
    S
  ]);
  return /* @__PURE__ */ M(F, {
    router: L,
    children: n
  });
};
export {
  ee as ReactRouterAdapter
};

//# sourceMappingURL=ReactRouterAdapter.js.map